export default __webpack_public_path__ + "static/media/158.6ffb4088.png";